export default "__VITE_ASSET__CqTwyMhV__"